import type { Technician } from '@shared/types';

// Helper function to generate regie interventions for Marc
const generateRegieDay = (date: string, startId: number): any[] => {
    const companies = [
        'Manufrance', 'Caisse d\'Épargne', 'Décathlon', 'Intermarché', 'Leroy Merlin',
        'Boulangerie Paul', 'Pharmacie Centrale', 'McDonald\'s', 'SNCF Gare', 'Optical Center',
        'Auchan', 'Garage Renault', 'Lidl', 'Quick Burger', 'Conforama',
        'H&M', 'FNAC', 'BUT', 'Go Sport', 'Kiabi',
        'Crédit Agricole', 'La Poste', 'Cultura', 'Burger King', 'Picard',
        'Monoprix', 'Yves Rocher', 'Nocibé', 'Jeff de Bruges', 'Orchestra',
        'Subway', 'Sephora', 'Jules', 'Mim', 'Jennyfer',
        'Carrefour City', 'Bricomarché', 'Action', 'Gifi', 'Centrakor',
    ];
    const tasks = ['Maintenance', 'Dépannage', 'Contrôle', 'Réparation', 'Vérification'];

    return [
        { id: `r${startId}`, clientName: companies[(startId) % companies.length], startDate: date, endDate: date, task: tasks[0], address: 'Centre Ville', city: 'Saint-Étienne', postalCode: '42000', startTime: '08:00', endTime: '09:30', color: '#f87171', includeWeekends: false },
        { id: `r${startId + 1}`, clientName: companies[(startId + 1) % companies.length], startDate: date, endDate: date, task: tasks[1], address: 'Zone Commercial', city: 'Saint-Étienne', postalCode: '42100', startTime: '10:00', endTime: '11:00', color: '#f87171', includeWeekends: false },
        { id: `r${startId + 2}`, clientName: companies[(startId + 2) % companies.length], startDate: date, endDate: date, task: tasks[2], address: 'Steel', city: 'Saint-Étienne', postalCode: '42000', startTime: '11:30', endTime: '12:30', color: '#f87171', includeWeekends: false },
        { id: `r${startId + 3}`, clientName: companies[(startId + 3) % companies.length], startDate: date, endDate: date, task: tasks[3], address: 'Monthieu', city: 'Saint-Étienne', postalCode: '42000', startTime: '14:00', endTime: '15:00', color: '#f87171', includeWeekends: false },
        { id: `r${startId + 4}`, clientName: companies[(startId + 4) % companies.length], startDate: date, endDate: date, task: tasks[4], address: 'Fauriel', city: 'Saint-Étienne', postalCode: '42100', startTime: '15:30', endTime: '17:00', color: '#f87171', includeWeekends: false },
    ];
};

export const DEMO_TECHNICIANS: Technician[] = [
    {
        id: '1',
        name: 'Laura',
        service: 'Maintenance',
        color: '#f472b6',
        overrides: {
            '2026-01-05': 'vacation',
            '2026-01-06': 'vacation',
            '2026-01-07': 'vacation',
            '2026-02-14': 'vacation',
        },
        assignments: [
            // Janvier - Chantiers continus
            { id: 'a1', clientName: 'Casino Supermarchés', startDate: '2026-01-02', endDate: '2026-01-03', task: 'Maintenance urgente entrepôt', address: '1 Esplanade de France', city: 'Saint-Étienne', postalCode: '42000', startTime: '08:00', endTime: '17:00', color: '#f472b6', includeWeekends: false },
            // 5-7 = Congés
            { id: 'a2', clientName: 'CHU Saint-Étienne', startDate: '2026-01-08', endDate: '2026-01-16', task: 'Révision équipements médicaux', address: 'Avenue Albert Raimond', city: 'Saint-Étienne', postalCode: '42270', contactName: 'M. Dubois', contactPhone: '04 77 12 05 00', startTime: '08:00', endTime: '17:00', color: '#f472b6', includeWeekends: false },
            { id: 'a3', clientName: 'Groupe SEB', startDate: '2026-01-19', endDate: '2026-01-23', task: 'Installation nouveaux équipements', address: 'ZI du Pont', city: 'Rumilly', postalCode: '42330', startTime: '09:00', endTime: '16:00', color: '#f472b6', includeWeekends: false },
            { id: 'a4', clientName: 'Michelin Centre Tech', startDate: '2026-01-26', endDate: '2026-01-30', task: 'Maintenance machines', address: 'Place des Carmes', city: 'Clermont-Ferrand', postalCode: '63000', color: '#f472b6', includeWeekends: false },

            // Février
            { id: 'a5', clientName: 'Carrefour Monthieu', startDate: '2026-02-02', endDate: '2026-02-06', task: 'Réparation groupes froids', address: 'Route de Firminy', city: 'Saint-Étienne', postalCode: '42000', color: '#f472b6', includeWeekends: false },
            { id: 'a6', clientName: 'Tour Part-Dieu LCL', startDate: '2026-02-09', endDate: '2026-02-13', task: 'Maintenance immeuble', address: 'Rue Servient', city: 'Lyon', postalCode: '69003', color: '#f472b6', includeWeekends: false },
            // 14 = Congé
            { id: 'a7', clientName: 'Hôpital Privé Loire', startDate: '2026-02-16', endDate: '2026-02-28', task: 'Révision complète', address: 'Rue Ambroise Paré', city: 'Saint-Étienne', postalCode: '42100', contactPhone: '04 77 49 62 62', startTime: '07:00', endTime: '19:00', color: '#f472b6', includeWeekends: true },
        ],
    },
    {
        id: '2',
        name: 'Thomas',
        service: 'Maintenance',
        color: '#22d3ee',
        overrides: {
            '2026-01-15': 'star',
            '2026-02-20': 'vacation',
            '2026-02-21': 'vacation',
        },
        assignments: [
            // Janvier
            { id: 'b1', clientName: 'Stade Geoffroy-Guichard', startDate: '2026-01-02', endDate: '2026-01-09', task: 'Maintenance installations sportives', address: 'Rue Paul Guichard', city: 'Saint-Étienne', postalCode: '42000', color: '#22d3ee', includeWeekends: false },
            { id: 'b2', clientName: 'Aéroport Lyon', startDate: '2026-01-12', endDate: '2026-01-14', task: 'Support maintenance', address: 'Terminal 1', city: 'Colombier-Saugnieu', postalCode: '69125', startTime: '06:00', endTime: '22:00', color: '#22d3ee', includeWeekends: false },
            // 15 = Astreinte
            { id: 'b3', clientName: 'Auchan Saint-Étienne', startDate: '2026-01-16', endDate: '2026-01-22', task: 'Maintenance équipements', address: 'Boulevard Daguerre', city: 'Saint-Étienne', postalCode: '42000', color: '#22d3ee', includeWeekends: false },
            { id: 'b4', clientName: 'PSA Saint-Bonnet', startDate: '2026-01-23', endDate: '2026-01-30', task: 'Installation bornes électriques', address: 'Route de Paris', city: 'Saint-Bonnet-de-Mure', postalCode: '69720', color: '#22d3ee', includeWeekends: false },

            // Février
            { id: 'b5', clientName: 'Casino Centre Distribution', startDate: '2026-02-02', endDate: '2026-02-07', task: 'Maintenance plateforme logistique', address: 'Esplanade France', city: 'Saint-Étienne', postalCode: '42000', color: '#22d3ee', includeWeekends: false },
            { id: 'b6', clientName: 'Leroy Merlin', startDate: '2026-02-09', endDate: '2026-02-19', task: 'Révision systèmes', address: 'Rochetaillée', city: 'Saint-Étienne', postalCode: '42100', color: '#22d3ee', includeWeekends: false },
            // 20-21 = Congés
            { id: 'b7', clientName: 'Décathlon Logistics', startDate: '2026-02-23', endDate: '2026-02-28', task: 'Maintenance entrepôt', address: 'ZAC Pont Âne', city: 'Saint-Étienne', postalCode: '42100', color: '#22d3ee', includeWeekends: false },
        ],
    },
    {
        id: '3',
        name: 'Marie',
        service: 'Reseau',
        color: '#a78bfa',
        overrides: {
            '2026-02-09': 'vacation',
            '2026-02-10': 'vacation',
            '2026-02-11': 'vacation',
            '2026-02-12': 'vacation',
            '2026-02-13': 'vacation',
        },
        assignments: [
            // Janvier - Couverture complète
            { id: 'c1', clientName: 'Université Jean Monnet', startDate: '2026-01-02', endDate: '2026-01-16', task: 'Déploiement WiFi campus', address: 'Rue Tréfilerie', city: 'Saint-Étienne', postalCode: '42023', contactPhone: '04 77 42 13 00', color: '#a78bfa', includeWeekends: false },
            { id: 'c2', clientName: 'Banque Populaire Loire', startDate: '2026-01-19', endDate: '2026-01-23', task: 'Infrastructure réseau', address: 'Rue République', city: 'Lyon', postalCode: '69002', startTime: '09:00', endTime: '18:00', color: '#a78bfa', includeWeekends: false },
            { id: 'c3', clientName: 'Datacenter AxiomCloud', startDate: '2026-01-26', endDate: '2026-01-30', task: 'Optimisation réseau', address: 'ZA Combaruches', city: 'Andrézieux', postalCode: '42160', color: '#a78bfa', includeWeekends: false },

            // Février
            { id: 'c4', clientName: 'Groupe SEB IT', startDate: '2026-02-02', endDate: '2026-02-06', task: 'Sécurisation réseau', address: 'ZI Pont', city: 'Rumilly', postalCode: '42330', color: '#a78bfa', includeWeekends: false },
            // 9-13 = Congés
            { id: 'c5', clientName: 'Hospices Civils Lyon', startDate: '2026-02-16', endDate: '2026-02-28', task: 'Réseau médical', address: 'Quai Célestins', city: 'Lyon', postalCode: '69002', contactPhone: '04 72 40 20 20', startTime: '08:00', endTime: '17:00', color: '#a78bfa', includeWeekends: false },
        ],
    },
    {
        id: '4',
        name: 'Sophie',
        service: 'Électricité',
        color: '#fb923c',
        overrides: {
            '2026-01-22': 'star',
            '2026-02-05': 'vacation',
        },
        assignments: [
            // Janvier
            { id: 'd1', clientName: 'Résidence Les Terrasses', startDate: '2026-01-02', endDate: '2026-01-16', task: 'Rénovation électrique', address: 'Cours Fauriel', city: 'Saint-Étienne', postalCode: '42100', color: '#fb923c', includeWeekends: false },
            { id: 'd2', clientName: 'Paul Bocuse Brasserie', startDate: '2026-01-19', endDate: '2026-01-21', task: 'Mise aux normes', address: 'Place Jules Ferry', city: 'Lyon', postalCode: '69006', startTime: '07:00', endTime: '11:00', color: '#fb923c', includeWeekends: false },
            // 22 = Astreinte
            { id: 'd3', clientName: 'Intermarché Centre Deux', startDate: '2026-01-23', endDate: '2026-01-30', task: 'Installation LED', address: 'Boulevard Marx', city: 'Saint-Étienne', postalCode: '42000', color: '#fb923c', includeWeekends: false },

            // Février
            { id: 'd4', clientName: 'FNAC Saint-Étienne', startDate: '2026-02-02', endDate: '2026-02-04', task: 'Maintenance électrique', address: 'Place du Peuple', city: 'Saint-Étienne', postalCode: '42000', color: '#fb923c', includeWeekends: false },
            // 5 = Congé
            { id: 'd5', clientName: 'PSA Saint-Bonnet', startDate: '2026-02-06', endDate: '2026-02-20', task: 'Bornes recharge', address: 'Route Paris', city: 'Saint-Bonnet', postalCode: '69720', color: '#fb923c', includeWeekends: false },
            { id: 'd6', clientName: 'Centre Commercial Monthieu', startDate: '2026-02-23', endDate: '2026-02-28', task: 'Modernisation LED', address: 'Route Firminy', city: 'Saint-Étienne', postalCode: '42000', color: '#fb923c', includeWeekends: true },
        ],
    },
    {
        id: '5',
        name: 'Julien',
        service: 'Plomberie',
        color: '#34d399',
        overrides: {
            '2026-01-26': 'star',
            '2026-02-23': 'vacation',
            '2026-02-24': 'vacation',
            '2026-02-25': 'vacation',
        },
        assignments: [
            // Janvier
            { id: 'e1', clientName: 'Piscine Mâcheferienne', startDate: '2026-01-02', endDate: '2026-01-09', task: 'Maintenance filtration', address: 'Boulevard Bobet', city: 'Saint-Chamond', postalCode: '42400', startTime: '06:00', endTime: '14:00', color: '#34d399', includeWeekends: false },
            { id: 'e2', clientName: 'CHU Saint-Étienne', startDate: '2026-01-12', endDate: '2026-01-16', task: 'Révision plomberie', address: 'Avenue Raimond', city: 'Saint-Étienne', postalCode: '42270', color: '#34d399', includeWeekends: false },
            { id: 'e3', clientName: 'Mercure Hotel Lyon', startDate: '2026-01-19', endDate: '2026-01-23', task: 'Maintenance SPA', address: 'Cours Charlemagne', city: 'Lyon', postalCode: '69002', color: '#34d399', includeWeekends: false },
            // 26 = Astreinte
            { id: 'e4', clientName: 'Campus ENISE', startDate: '2026-01-27', endDate: '2026-01-30', task: 'Rénovation sanitaires', address: 'Rue Jean Parot', city: 'Saint-Étienne', postalCode: '42000', color: '#34d399', includeWeekends: false },

            // Février
            { id: 'e5', clientName: 'Résidence Grand Sud', startDate: '2026-02-02', endDate: '2026-02-06', task: 'Maintenance copropriété', address: 'Rue Bergson', city: 'Saint-Étienne', postalCode: '42000', color: '#34d399', includeWeekends: false },
            { id: 'e6', clientName: 'Stade Geoffroy', startDate: '2026-02-09', endDate: '2026-02-20', task: 'Plomberie vestiaires', address: 'Rue Guichard', city: 'Saint-Étienne', postalCode: '42000', color: '#34d399', includeWeekends: false },
            // 23-25 = Congés
            { id: 'e7', clientName: 'Hôpital Privé Loire', startDate: '2026-02-26', endDate: '2026-02-28', task: 'Plomberie médicale', address: 'Rue Paré', city: 'Saint-Étienne', postalCode: '42100', startTime: '07:00', endTime: '19:00', color: '#34d399', includeWeekends: false },
        ],
    },
    {
        id: '6',
        name: 'Camille',
        service: 'Climatisation',
        color: '#60a5fa',
        overrides: {
            '2026-01-19': 'vacation',
            '2026-01-20': 'vacation',
            '2026-01-21': 'vacation',
            '2026-02-16': 'star',
        },
        assignments: [
            // Janvier
            { id: 'f1', clientName: 'Tour Part-Dieu Silex', startDate: '2026-01-02', endDate: '2026-01-16', task: 'Installation clim étages', address: 'Rue Bonnel', city: 'Lyon', postalCode: '69003', startTime: '08:00', endTime: '17:00', color: '#60a5fa', includeWeekends: false },
            // 19-21 = Congés
            { id: 'f2', clientName: 'Darty Saint-Étienne', startDate: '2026-01-22', endDate: '2026-01-30', task: 'Maintenance refroidissement', address: 'Rue Presse', city: 'Saint-Étienne', postalCode: '42000', color: '#60a5fa', includeWeekends: false },

            // Février
            { id: 'f3', clientName: 'Datacenter Axiom', startDate: '2026-02-02', endDate: '2026-02-13', task: 'Refroidissement serveurs', address: 'ZA Combaruches', city: 'Andrézieux', postalCode: '42160', startTime: '00:00', endTime: '06:00', color: '#60a5fa', includeWeekends: true },
            // 16 = Astreinte
            { id: 'f4', clientName: 'Hospices Lyon', startDate: '2026-02-17', endDate: '2026-02-28', task: 'Clim blocs opératoires', address: 'Place Arsonval', city: 'Lyon', postalCode: '69003', startTime: '08:00', endTime: '17:00', color: '#60a5fa', includeWeekends: false },
        ],
    },
    {
        id: '7',
        name: 'Marc',
        service: 'Maintenance',
        color: '#f87171',
        overrides: {},
        assignments: [
            // JANVIER - 5 interventions régie par jour (tous les jours ouvrés)
            ...generateRegieDay('2026-01-02', 1),
            ...generateRegieDay('2026-01-05', 6),
            ...generateRegieDay('2026-01-06', 11),
            ...generateRegieDay('2026-01-07', 16),
            ...generateRegieDay('2026-01-08', 21),
            ...generateRegieDay('2026-01-09', 26),
            ...generateRegieDay('2026-01-12', 31),
            ...generateRegieDay('2026-01-13', 36),
            ...generateRegieDay('2026-01-14', 41),
            ...generateRegieDay('2026-01-15', 46),
            ...generateRegieDay('2026-01-16', 51),
            ...generateRegieDay('2026-01-19', 56),
            ...generateRegieDay('2026-01-20', 61),
            ...generateRegieDay('2026-01-21', 66),
            ...generateRegieDay('2026-01-22', 71),
            ...generateRegieDay('2026-01-23', 76),
            ...generateRegieDay('2026-01-26', 81),
            ...generateRegieDay('2026-01-27', 86),
            ...generateRegieDay('2026-01-28', 91),
            ...generateRegieDay('2026-01-29', 96),
            ...generateRegieDay('2026-01-30', 101),

            // FÉVRIER
            ...generateRegieDay('2026-02-02', 106),
            ...generateRegieDay('2026-02-03', 111),
            ...generateRegieDay('2026-02-04', 116),
            ...generateRegieDay('2026-02-05', 121),
            ...generateRegieDay('2026-02-06', 126),
            ...generateRegieDay('2026-02-09', 131),
            ...generateRegieDay('2026-02-10', 136),
            ...generateRegieDay('2026-02-11', 141),
            ...generateRegieDay('2026-02-12', 146),
            ...generateRegieDay('2026-02-13', 151),
            ...generateRegieDay('2026-02-16', 156),
            ...generateRegieDay('2026-02-17', 161),
            ...generateRegieDay('2026-02-18', 166),
            ...generateRegieDay('2026-02-19', 171),
            ...generateRegieDay('2026-02-20', 176),
            ...generateRegieDay('2026-02-23', 181),
            ...generateRegieDay('2026-02-24', 186),
            ...generateRegieDay('2026-02-25', 191),
            ...generateRegieDay('2026-02-26', 196),
            ...generateRegieDay('2026-02-27', 201),
        ],
    },
    {
        id: '8',
        name: 'Léa',
        service: 'Reseau',
        color: '#c084fc',
        overrides: {
            '2026-01-12': 'star',
            '2026-02-26': 'vacation',
            '2026-02-27': 'vacation',
        },
        assignments: [
            // Janvier
            { id: 'h1', clientName: 'Village by CA Startup', startDate: '2026-01-02', endDate: '2026-01-09', task: 'Installation réseau bureaux', address: 'Place Anatole France', city: 'Saint-Étienne', postalCode: '42000', startTime: '09:00', endTime: '18:00', color: '#c084fc', includeWeekends: false },
            // 12 = Astreinte
            { id: 'h2', clientName: 'Lycée Claude Fauriel', startDate: '2026-01-13', endDate: '2026-01-23', task: 'Réseau pédagogique', address: 'Avenue Libération', city: 'Saint-Étienne', postalCode: '42000', color: '#c084fc', includeWeekends: false },
            { id: 'h3', clientName: 'Cité du Design', startDate: '2026-01-26', endDate: '2026-01-30', task: 'Infrastructure événement', address: 'Rue Javelin Pagnon', city: 'Saint-Étienne', postalCode: '42000', color: '#c084fc', includeWeekends: false },

            // Février
            { id: 'h4', clientName: 'Médiathèque Tarentaize', startDate: '2026-02-02', endDate: '2026-02-13', task: 'Modernisation réseau', address: 'Rue Tarentaize', city: 'Saint-Étienne', postalCode: '42000', color: '#c084fc', includeWeekends: false },
            { id: 'h5', clientName: 'Université Jean Monnet', startDate: '2026-02-16', endDate: '2026-02-25', task: 'Support WiFi', address: 'Rue Tréfilerie', city: 'Saint-Étienne', postalCode: '42023', color: '#c084fc', includeWeekends: false },
            // 26-27 = Congés
            { id: 'h6', clientName: 'Casino IT', startDate: '2026-02-28', endDate: '2026-02-28', task: 'Sécurité réseau', address: 'Esplanade France', city: 'Saint-Étienne', postalCode: '42000', startTime: '08:00', endTime: '17:00', color: '#c084fc', includeWeekends: false },
        ],
    },
];
